/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Line_Breaks_HelpInputs */

const en_options_editor_auto_line_breaks_help = /** @type {(inputs: Options_Editor_Auto_Line_Breaks_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The editor will automatically insert line breaks based on the maximum characters per line found in the Event Group error settings.`)
};

const fr_options_editor_auto_line_breaks_help = /** @type {(inputs: Options_Editor_Auto_Line_Breaks_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'éditeur insère automatiquement des retours à la ligne en fonction du nombre maximal de caractères par ligne défini dans les paramètres d'erreurs du groupe d'événements.`)
};

const de_options_editor_auto_line_breaks_help = /** @type {(inputs: Options_Editor_Auto_Line_Breaks_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Editor fügt automatisch Zeilenumbrüche basierend auf der maximalen Zeichenanzahl pro Zeile ein, die in den Fehlereinstellungen der Ereignisgruppe festgelegt ist.`)
};

const it_options_editor_auto_line_breaks_help = /** @type {(inputs: Options_Editor_Auto_Line_Breaks_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'editor inserirà automaticamente le interruzioni di riga in base al numero massimo di caratteri per riga indicato nelle impostazioni di errore del gruppo eventi.`)
};

const ru_options_editor_auto_line_breaks_help = /** @type {(inputs: Options_Editor_Auto_Line_Breaks_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактор автоматически вставит переносы строк, исходя из максимального количества символов в строке, указанного в настройках ошибок группы событий.`)
};

const es_options_editor_auto_line_breaks_help = /** @type {(inputs: Options_Editor_Auto_Line_Breaks_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El editor insertará automáticamente saltos de línea en función del máximo de caracteres por línea encontrados en la configuración de error del Grupo de eventos.`)
};

const zh_cn2_options_editor_auto_line_breaks_help = /** @type {(inputs: Options_Editor_Auto_Line_Breaks_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑器将根据事件组错误设置中找到的每行最大字符数自动插入换行符。`)
};

const ja_options_editor_auto_line_breaks_help = /** @type {(inputs: Options_Editor_Auto_Line_Breaks_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エディターは、イベント グループのエラー設定で指定された行あたりの最大文字数に基づいて、自動的に改行を挿入します。`)
};

const hi_options_editor_auto_line_breaks_help = /** @type {(inputs: Options_Editor_Auto_Line_Breaks_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप त्रुटि सेटिंग्स में प्रति पंक्ति अधिकतम वर्णों की संख्या के आधार पर संपादक स्वचालित रूप से पंक्ति विराम सम्मिलित करेगा।`)
};

const pt_pt2_options_editor_auto_line_breaks_help = /** @type {(inputs: Options_Editor_Auto_Line_Breaks_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O editor irá inserir automaticamente quebras de linha com base no número máximo de caracteres por linha encontrado nas configurações de erro do Grupo de Eventos.`)
};

/**
* | output |
* | --- |
* | "The editor will automatically insert line breaks based on the maximum characters per line found in the Event Group error settings." |
*
* @param {Options_Editor_Auto_Line_Breaks_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_line_breaks_help = /** @type {((inputs?: Options_Editor_Auto_Line_Breaks_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Line_Breaks_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_auto_line_breaks_help(inputs)
	if (locale === "de") return de_options_editor_auto_line_breaks_help(inputs)
	if (locale === "it") return it_options_editor_auto_line_breaks_help(inputs)
	if (locale === "ru") return ru_options_editor_auto_line_breaks_help(inputs)
	if (locale === "es") return es_options_editor_auto_line_breaks_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_auto_line_breaks_help(inputs)
	if (locale === "ja") return ja_options_editor_auto_line_breaks_help(inputs)
	if (locale === "hi") return hi_options_editor_auto_line_breaks_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_auto_line_breaks_help(inputs)
	return en_options_editor_auto_line_breaks_help(inputs)
});